// Navegación anterior/siguiente entre productos de una colección.
// Idea: en la colección capturamos (al hacer clic) el orden YA filtrado/ordenado
// que el usuario ve en el DOM y lo guardamos. En el producto leemos esa lista y
// pintamos los botones. El filtro se preserva solo porque el orden ya viene filtrado.
(function () {
  var KEY = 'pn:nav';
  var handleOf = function (url) {
    var m = url && url.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  };

  // --- Captura en la colección ---
  // #ProductGridContainer sobrevive al re-render AJAX de los facets; la delegación aguanta.
  var container = document.getElementById('ProductGridContainer');
  if (container) {
    var capture = function () {
      var seen = {}, items = [];
      container.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var h = handleOf(a.getAttribute('href'));
        if (h && !seen[h]) { seen[h] = 1; items.push(a.href.split('#')[0]); }
      });
      try { sessionStorage.setItem(KEY, JSON.stringify(items)); } catch (_) {}
    };
    // 'click' cubre tap/clic izquierdo; 'auxclick' cubre clic central (abrir en pestaña).
    container.addEventListener('click', function (e) {
      if (e.target.closest('a[href*="/products/"]')) capture();
    }, true);
    container.addEventListener('auxclick', function (e) {
      if (e.target.closest('a[href*="/products/"]')) capture();
    }, true);
  }

  // --- Render en el producto ---
  var mount = document.getElementById('product-nav');
  if (!mount) return;

  var items;
  try { items = JSON.parse(sessionStorage.getItem(KEY)); } catch (_) {}
  if (!items || items.length < 2) return; // sin contexto de colección: sin botones

  var current = handleOf(location.pathname);
  var idx = items.map(handleOf).indexOf(current);
  if (idx === -1) return;

  var chevron = function (dir) {
    var d = dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };
  var btn = function (url, dir, label) {
    if (!url) return '';
    return '<a class="product-nav__btn product-nav__btn--' + dir + '" href="' + url +
      '" rel="' + dir + '" aria-label="' + label + '">' + chevron(dir) + '</a>';
  };

  var prev = items[idx - 1], next = items[idx + 1];
  mount.innerHTML = btn(prev, 'prev', 'Producto anterior') +
                    btn(next, 'next', 'Producto siguiente');

  // Prefetch de los vecinos para que el salto se sienta instantáneo.
  [prev, next].forEach(function (url) {
    if (!url) return;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  });
})();
